import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingGroupItem} from './pricing-group-item';
import {PricingCategory} from '../pricing-category';

@JsonObject('model.PricingGroup')
export class PricingGroup extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty([PricingGroupItem], 'items')
  items?: PricingGroupItem[]

  @JsonProperty(PricingCategory, 'pricingCategory')
  pricingCategory?: PricingCategory

  @JsonProperty(Number, 'totalSQFT')
  totalSQFT?: number

  @JsonProperty(Number, 'totalQty')
  totalQty?: number

  updateFromGroupId?: number

  @JsonProperty(String, 'lastInteractionTime')
  lastInteractionTime?: string;
}

